import { colors } from "../../utils/colors";

export const Balance = () => {
    return (
        <div className="balance-section">
            <h3 style={{ fontSize: "120px", textAlign: "center" }}>$25,000.00</h3>
            <p style={{ textAlign: "center", color: colors.purple, textDecoration: "underline dotted" }}>
                Available balance as of today
            </p>
        </div>
    );
};
